import { getTenant } from "@/api/tenant";
import router, { resetRouter } from "@/router";
import getPageTitle from "@/utils/get-page-title";
import { Message } from "element-ui";

let lastRoles;

const store = window.store;

router.beforeEach(async (to, _, next) => {
  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = store.getters["operators/token"];
  let { url, key } = getTenant();

  // determine user authentication state
  let userState = "SETUP_REQUIRED";

  if (url && key) {
    userState = "LOGIN_REQUIRED";
  }

  if (userState === "LOGIN_REQUIRED" && hasToken) {
    userState = "LOGGED_IN";
  }

  // actuate depending the user state
  switch (userState) {
    case "SETUP_REQUIRED":
      if (to.path !== "/setup") {
        return next({ path: "/setup" });
      }
      break;

    case "LOGIN_REQUIRED":
      if (to.path !== "/login") {
        return next({ path: "/login" });
      }
      break;

    case "LOGGED_IN":
      if (to.path === "/login" || to.path === "/setup") {
        return next({ path: "/" });
      } else {
        const roles = [store.getters["operators/operator"].rol];
        const hasRoles = roles.length > 0;
        if (!hasRoles || JSON.stringify(lastRoles) !== JSON.stringify(roles)) {
          resetRouter();
          try {
            // get user info
            // NOTE: roles must be a object array! such as: ['admin'] or ,['developer','editor']
            lastRoles = roles;

            // generate accessible routes map based on roles
            const accessRoutes = await store.dispatch("permission/generateRoutes", roles);

            // dynamically add accessible routes
            for (const route of accessRoutes) {
              router.addRoute(route);
            }

            // method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            return next({ ...to, replace: true });
          } catch (error) {
            console.error(error);
            // remove token and go to login page to re-login
            await store.dispatch("user/resetToken");
            Message.error(error || "Has Error");

            return next(`/login?redirect=${to.path}`);
          }
        }
      }
      break;
  }

  // complete progress bar
  return next();
});
